import React, { useEffect, useState } from 'react' // Added useState
import { useSelector } from 'react-redux'
import WalletContext from '../pages/walletContext'
import 'antd/dist/reset.css'

import '../styles/style.css'
import Routes from './Routes'
import { light, dark } from './theme'

const App = () => {
  const theme = useSelector((state) => state.theme.theme)

  const [address, setAddress] = useState(null)
  const [balance, setBalance] = useState(null)

  useEffect(() => {
    if (theme === 'light') {
      Object.keys(light).forEach((key) => {
        document.body.style.setProperty(`--${key}`, light[key])
      })
    } else {
      Object.keys(dark).forEach((key) => {
        document.body.style.setProperty(`--${key}`, dark[key])
      })
    }
  }, [theme])

  return (
    <WalletContext.Provider value={{ address, balance, setAddress, setBalance }}>
      <Routes />
    </WalletContext.Provider>
  )
}

export default App
